import React from 'react';
import { motion } from 'framer-motion';
export function Dashboard() {
  return <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center p-6 text-center" data-id="element-25">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className="max-w-sm w-full" data-id="element-26">
        <div className="w-12 h-12 bg-blue-600/20 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(37,99,235,0.15)]" data-id="element-27">
          <div className="w-6 h-6 bg-blue-500 rounded-full shadow-[0_0_15px_rgba(37,99,235,0.5)]" data-id="element-28" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-3 tracking-tight" data-id="element-29">
          Welcome to BetIQ
        </h1>
        <p className="text-zinc-400 text-sm" data-id="element-30">Dashboard coming soon.</p>
      </motion.div>
    </div>;
}